import { memo, useCallback, useMemo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useRewardSystemUser } from 'hooks/rewardSystem/useRewardSystemUser';

import {
  useGetCompanyQuery,
  useGetSeasonQuery,
} from 'store/api/strapiService/rewardSystemController';

import { getCoinsAccrued } from 'utils/rewardSystem';

import Button from 'components/UI/Button/Button';
import ToggleFilters from 'components/UI/ToggleFilters/ToggleFilters';
import Typography from 'components/UI/Typography/Typography';

import { TABS } from 'components/config/rewardSystem';

import { ReactComponent as CupIcon } from 'images/Icons/Cup.svg';
import CoinIcon from 'images/RewardSystem/coin.png';

import styles from './Header.module.scss';

const Header = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { companyId, shopLink } = useRewardSystemUser();

  const { data: companyData } = useGetCompanyQuery(
    { id: companyId },
    { skip: !companyId },
  );

  const currentSeasonId = useMemo(
    () => companyData?.data?.seasons?.[0]?.documentId,
    [companyData],
  );

  const { data: seasonData } = useGetSeasonQuery(
    { id: currentSeasonId },
    { skip: !currentSeasonId },
  );

  const season = seasonData?.data;

  const handleTabsChange = useCallback((_, value) => navigate(value), []);

  const pagePath = useMemo(
    () => pathname.slice(pathname.lastIndexOf('/') + 1),
    [pathname],
  );

  const coinsAccrued = useMemo(() => getCoinsAccrued(season), [season]);

  return (
    <div className={styles.root}>
      <div className={styles.items}>
        <ToggleFilters
          value={pagePath}
          options={TABS}
          onChange={handleTabsChange}
        />
        {season && (
          <div className={styles.rewardInfo}>
            <div className={styles.season}>
              <CupIcon />
              <Typography weight="medium" color="inherit">
                {season.name}
              </Typography>
            </div>
            <div className={styles.balance}>
              <img src={CoinIcon} alt="coin icon" className={styles.coinIcon} />
              <Typography
                weight="medium"
                color="inherit"
                className={styles.balanceValue}
              >
                {coinsAccrued}
              </Typography>
            </div>
          </div>
        )}
      </div>
      <Button
        component={Link}
        to={shopLink}
        rel="noopener"
        target="_blank"
        variant="secondary"
        className={styles.shopBtn}
      >
        Shop
      </Button>
    </div>
  );
};

export default memo(Header);
